export var StateKey = 'oidc-state';
export var IdTokenKey = 'oidc-idtoken';
export var ReturnToKey = 'returnTo';
export var LoginRoute = 'auth.login';
export var LogoutRoute = 'auth.logout';
export var AuthRoutes = [
    { name: LoginRoute, path: 'oidc-login', component: function () { return import('../views/login.vue'); } },
    { name: LogoutRoute, path: 'oidc-logout', component: function () { return import('../views/logout.vue'); } }
];
